import { Box, Skeleton } from "@mui/material";

export const ChartLoadingSkeleton = () => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-end",
        justifyContent: "space-between",
        height: 300,
        width: "100%",
        px: 2,
      }}
    >
      {[...Array(10)].map((_, index) => (
        <Skeleton
          key={index}
          variant="rectangular"
          animation="wave"
          width={30}
          height={Math.floor(Math.random() * 200) + 50}
          sx={{
            borderRadius: "6px",
            backgroundColor: "#f0f0f0",
          }}
        />
      ))}
    </Box>
  );
};
